import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO_DEFAULTS, SCHEMA_DENTAL_PRACTICE, buildTitle } from '../../utils/seo';

export default function SEOHead({
  title,
  description = SEO_DEFAULTS.defaultDescription,
  keywords = SEO_DEFAULTS.defaultKeywords,
  canonical,
  schema,
  noindex = false,
}) {
  const fullTitle = buildTitle(title);
  const url = canonical ? `${SEO_DEFAULTS.siteUrl}${canonical}` : SEO_DEFAULTS.siteUrl;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={SEO_DEFAULTS.siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />

      {/* Schema.org */}
      <script type="application/ld+json">
        {JSON.stringify(schema || SCHEMA_DENTAL_PRACTICE)}
      </script>
    </Helmet>
  );
}
